import React from 'react';

import BaseSvg, { BaseSvgProps } from '../../BaseSvg';

const PiercingSvg: React.FunctionComponent<BaseSvgProps> = ({ className = '', fillColor, secondaryFillColor }) => {
    return (
        <BaseSvg className={className} viewBox="0 0 21.17 18.95">
            <polygon
                fill={fillColor}
                points="10.63 9.48 13.07 3.78 7.76 6.5 9.98 1.47 6.26 5.16 6.26 0 1.73 9.48 6.26 18.95 6.26 13.8 9.98 17.48 7.76 12.45 13.07 15.17 10.63 9.48"
            />
            <path
                fill={fillColor}
                d="M13.31,12.64c-2.59,0-8.5-.75-11.1-2.55l-.89-.62.89-.62c2.6-1.8,8.51-2.55,11.1-2.55h7.11v6.33Z"
            />
            <path
                fill={secondaryFillColor}
                d="M19.67,7.06v4.83H13.31c-2.55,0-8.29-.76-10.67-2.41C5,7.82,10.75,7.06,13.31,7.06h6.36m1.5-1.5H13.31c-2.67,0-8.79.79-11.53,2.68L0,9.48l1.78,1.23c2.73,1.89,8.86,2.68,11.53,2.68h7.86V5.56Z"
            />
        </BaseSvg>
    );
};

export default PiercingSvg;
